// *****************************
// *****  Main Navigation  *****
// *****************************
import { breakPoint } from './config';
import { keyboardControl } from './keyboard-accessibility-check';
import { mainNavigation } from './global';

const $html = document.querySelector('html');
let isMobile = true,
    resizeRequested = false;

mainNavigation.setMobileActive(false);
mainNavigation.setDesktopActive(false);

class menu {

    constructor(wrapper, toggleButton, ul) {
        this.wrapper = wrapper;
        this.desktopSubmenuIndicator = wrapper.querySelector('.submenu--menu-indicator');
        this.navContent = wrapper.querySelector('nav');
        this.mobileToggle = toggleButton;
        this.ul = ul;
        this.expanded = false;
        this.focusTimeout = null;
        this.hideTimeout = null;
        this.hideDelay = 500;
        this.activeItemIndex = -1;
        this.activeSubmenuItemIndex = -1;
        this.items = [];
        [...this.ul.querySelectorAll('.header--content--menu > nav > ul > li')].forEach(i => {
            let x = this.items.length;
            this.items[x] = new menuItem(x, i, 1);
        });
    }

    show() {
        // make menu semantically visible in both mobile and desktop versions
        this.expanded = true;
        this.wrapper.removeAttribute('aria-hidden');
        if(isMobile) {
            // mobile - animate in the menu element
            this.mobileToggle.setAttribute('aria-expanded', true);
            $html.classList.add('mobile-menu-fading');
            mainNavigation.setMobileActive(true);
            window.requestAnimationFrame(() => {
                $html.classList.add('mobile-menu-active');
                this.wrapper.ontransitionend = () => {
                    this.transitionEnd(true);
                    this.update(true, 0, -1);
                };
            });
        } else {
            // desktop resets
            mainNavigation.setMobileActive(false);
            window.requestAnimationFrame(() => {
                $html.classList.remove('mobile-menu-active');
            });
        }
    }

    hide() {
        if(isMobile && mainNavigation.mobileActive) {
            // mobile - animate out menu element
            this.expanded = false;
            mainNavigation.setMobileActive(false);
            this.mobileToggle.setAttribute('aria-expanded', false);
            $html.classList.add('mobile-menu-fading');
            $html.classList.remove('mobile-menu-active');
            this.wrapper.ontransitionend = () => {
                this.transitionEnd(false);
            };
        } else {
            // hide menu semantically in both mobile and desktop versions
            this.expanded = false;
            this.wrapper.setAttribute('aria-hidden', true);
        }
    }

    transitionEnd(mode) {
        if(!mode) {
            // menu has hidden
            this.wrapper.setAttribute('aria-hidden', true);
        }
        $html.classList.remove('mobile-menu-fading');
        this.wrapper.ontransitionend = null;
    }

    storeTriggerPositions() {
        for(let x = 0, l = this.items.length; x < l; x++) {
            if(this.items[x].button != null) {
                let b = this.items[x].button.getBoundingClientRect();
                this.items[x].buttonX = Math.floor((b.left + b.right) / 2);
            }
        }
        if(this.desktopSubmenuIndicator != null && this.activeItemIndex > -1) this.desktopSubmenuIndicator.style.left = `${this.items[this.activeItemIndex].buttonX - 10}px`;
    }

    update(setFocus = false, itemIndex = -1, submenuItemIndex = -1) {
        if(!isMobile) this.storeTriggerPositions();
        if (itemIndex > -1 && submenuItemIndex > -1) {

            // FOCUS TARGET IS SUBMENU MENU ITEM

            if (isMobile && !this.expanded) this.show();
            // close old submenu without animation?
            if (this.activeItemIndex > -1 && this.activeSubmenuItemIndex > -1 && itemIndex != this.activeItemIndex && this.items[this.activeItemIndex].submenu.expanded) this.items[this.activeItemIndex].submenu.hide(isMobile);
            // desktop - update submenu indicator
            if(this.desktopSubmenuIndicator != null) this.desktopSubmenuIndicator.style.left = `${this.items[itemIndex].buttonX - 10}px`;
            // open new submenu
            if (!this.items[itemIndex].submenu.expanded) this.items[itemIndex].submenu.show(isMobile || (this.activeItemIndex == -1 || this.activeSubmenuItemIndex == -1));
            // focus on item
            if (keyboardControl.active && setFocus) {
                if(isMobile) {
                    this.items[itemIndex].submenu.mobileItems[submenuItemIndex].focus();
                } else {
                    this.items[itemIndex].submenu.desktopItems[submenuItemIndex].focus();
                }
            }

        } else if (itemIndex > -1) {

            // FOCUS TARGET IS TOP-LEVEL MENU ITEM

            if (isMobile && !this.expanded) this.show();
            // close old submenu with animation?
            if (this.activeItemIndex > -1 && this.items[this.activeItemIndex].hasSubmenu) {
                if (this.items[this.activeItemIndex].submenu.expanded) this.items[this.activeItemIndex].submenu.hide(true);
            }
            // focus on item
            if (keyboardControl.active && setFocus) {
                if (this.items[itemIndex].hasSubmenu) {
                    this.items[itemIndex].submenu.toggle.focus();
                } else {
                    this.items[itemIndex].link.focus();
                }
            }

        } else {
            if (this.activeItemIndex > -1 && this.activeSubmenuItemIndex > -1 && this.items[this.activeItemIndex].submenu.expanded) this.items[this.activeItemIndex].submenu.hide(!isMobile);
            if (isMobile && this.expanded) {
                this.hide();
                if (keyboardControl.active && setFocus) this.mobileToggle.focus();
            }
        }
        // update tabIndex setting
        if (this.activeItemIndex != itemIndex) {
            if (this.activeItemIndex > -1) {
                if (this.items[this.activeItemIndex].hasSubmenu) {
                    this.items[this.activeItemIndex].submenu.toggle.setAttribute('tabindex', '-1');
                } else {
                    this.items[this.activeItemIndex].link.setAttribute('tabindex', '-1');
                }
            }
            let nextTabIndex = itemIndex;
            if (!isMobile && nextTabIndex == -1) nextTabIndex = 0;
            if (nextTabIndex > -1) {
                if (this.items[nextTabIndex].hasSubmenu) {
                    this.items[nextTabIndex].submenu.toggle.setAttribute('tabindex', '0');
                } else {
                    this.items[nextTabIndex].link.setAttribute('tabindex', '0');
                }
            }
        }
        // store new values
        this.activeItemIndex = itemIndex;
        this.activeSubmenuItemIndex = submenuItemIndex;
    }
}

class menuItem {
    constructor(itemIndex, obj, level) {
        this.level = level;
        this.index = itemIndex;
        this.li = obj;
        this.button = obj.querySelector('button.submenu--toggle');
        this.buttonX = 0;
        let sub = obj.querySelector('div.submenu');
        if (this.button && sub) {
            this.hasSubmenu = true;
            this.submenu = new subMenu(sub, this.button, level);
        } else {
            this.hasSubmenu = false;
            this.link = obj.querySelector('a');
        }
    }
}

class subMenu {
    constructor(sub, button, level) {
        this.expanded = false;
        this.toggle = button;
        this.wrapper = sub;
        this.level = level;
        this.closeBtn = this.wrapper.querySelector('.submenu--close');
        this.inner = this.wrapper.querySelector('.submenu--content-area');
        this.mobileItems = [];
        [...this.inner.querySelectorAll('a:not(.ignore-mobile), button:not(.ignore-mobile)')].forEach(i => {
            this.mobileItems.push(i);
        });
        this.desktopItems = [];
        [...this.inner.querySelectorAll('a, button')].forEach(i => {
            this.desktopItems.push(i);
        });
    }
    show(animate) {
        this.expanded = true;
        this.wrapper.removeAttribute('aria-hidden');
        this.toggle.setAttribute('aria-expanded', true);
        if(isMobile) {
            this.wrapper.style.maxHeight = this.inner.offsetHeight + 'px';
            if (animate) {
                this.wrapper.classList.add('animate');
                this.wrapper.ontransitionend = () => {
                    this.wrapper.classList.remove('animate');
                    if (this.level > 1 || isMobile) {
                        this.wrapper.style.maxHeight = 'none';
                        this.wrapper.ontransitionend = null;
                    }
                };
            } else {
                this.wrapper.style.maxHeight = 'none';
            }
        } else {
            this.wrapper.style.maxHeight = 'none';
            mainNavigation.setDesktopActive(true);
            if (animate) {
                window.requestAnimationFrame(() => {
                    $html.classList.add('desktop-menu-fading');
                    window.requestAnimationFrame(() => {
                        $html.classList.add('desktop-menu-active');
                        this.wrapper.ontransitionend = () => {
                            $html.classList.remove('desktop-menu-fading');
                            this.wrapper.ontransitionend = null;
                        };
                    });
                });
            } else {
                $html.classList.add('desktop-menu-active');
            }
        }
    }
    hide(animate) {
        this.expanded = false;
        if (isMobile) {
            this.wrapper.setAttribute('aria-hidden', true);
            this.toggle.setAttribute('aria-expanded', false);
            this.wrapper.style.maxHeight = this.inner.offsetHeight + 'px';
            window.requestAnimationFrame(() => {
                this.wrapper.style.maxHeight = 0;
            });
            if (animate) {
                this.wrapper.classList.add('animate');
                this.wrapper.ontransitionend = (e) => {
                    if(e.target == this.wrapper) this.wrapper.classList.remove('animate');
                };
            }
        } else {
            mainNavigation.setDesktopActive(false);
            if (animate) {
                $html.classList.add('desktop-menu-fading');
                $html.classList.remove('desktop-menu-active');
                this.wrapper.ontransitionend = () => {
                    this.wrapper.ontransitionend = null;
                    $html.classList.remove('desktop-menu-fading');
                    this.wrapper.setAttribute('aria-hidden', true);
                    this.toggle.setAttribute('aria-expanded', false);
                };
            } else {
                $html.classList.remove('desktop-menu-active');
                this.wrapper.setAttribute('aria-hidden', true);
                this.toggle.setAttribute('aria-expanded', false);
            }
        }
    }
}

// create instance of menu

if(document.querySelector('.header--content--menu') != null) {
    const m = new menu(document.querySelector('.header--content--menu'), document.querySelector('.header--content--menu-toggle button'), document.querySelector('.header--content--menu > nav > ul'));


    // mobile 'whole menu toggle' functionality

    m.mobileToggle.addEventListener('click', () => {
        if (isMobile) {
            if (m.expanded) {
                // close
                m.hide();
            } else {
                // open
                m.show();
            }
        }
    });

    // close menu if user focus moves outside

    const bodyClickTouch = (t) => {
        if (!isMobile && m.activeSubmenuItemIndex > -1) {
            let inMenu = false;
            while (t != document.body) {
                if (t == m.wrapper) {
                    inMenu = true;
                    break
                }
                t = t.parentNode;
            }
            if (!inMenu) {
                m.update();
            }
        }
    }
    document.body.addEventListener('click', (e) => {
        bodyClickTouch(e.target);
    });

    // add menu item listeners

    for (let x = 0, l = m.items.length; x < l; x++) {
        let o = m.items[x];
        if (o.hasSubmenu) {

            o.submenu.toggle.addEventListener('click', () => {
                clearTimeout(m.focusTimeout);
                m.focusTimeout = null;
                if (o.submenu.expanded) {
                    m.update(true, o.index);
                } else {
                    m.update(true, o.index, 0);
                }
            });

            o.submenu.toggle.addEventListener('focus', () => {
                if (m.expanded && m.activeItemIndex != o.index) {
                    clearTimeout(m.focusTimeout);
                    m.focusTimeout = setTimeout(() => {
                        m.update(true, o.index);
                        m.focusTimeout = null;
                    }, 250);
                }
            });

            // add submenu expander listeners if required

            let itemsArray = isMobile ? o.submenu.mobileItems : o.submenu.desktopItems;
            for (let xx = 0, ll = itemsArray.length; xx < ll; xx++) {
                let oo = itemsArray[xx];
                if (oo.hasSubmenu) {
                    oo.submenu.toggle.addEventListener('click', () => {
                        m.update(true, o.index, oo.index);
                    });
                }
            }

            // desktop only - submenu close button

            o.submenu.closeBtn.addEventListener('click', () => {
                if (o.submenu.expanded) m.update(true, o.index);
            });
        }
    }

    // add keyboard accessibility
    m.ul.addEventListener('keydown', (e) => {
        switch (e.key) {
            // ESCAPE jumps out a level
            case 'Escape':
                e.preventDefault();
                if (m.activeSubmenuItemIndex > -1) {
                    m.update(true, m.activeItemIndex);
                } else {
                    m.update(true);
                }
                break;
            // DOWN / RIGHT to move through items at current level
            case 'Down':
            case 'ArrowDown':
            case 'Right':
            case 'ArrowRight':
                e.preventDefault();
                if (m.activeSubmenuItemIndex > -1) {
                    let next = m.activeSubmenuItemIndex + 1,
                        list = isMobile? m.items[m.activeItemIndex].submenu.mobileItems : m.items[m.activeItemIndex].submenu.desktopItems;
                    if (next >= (isMobile ? list.length - 1 : list.length)) next = 0; // don't include submenu close button in mobile mode
                    m.update(true, m.activeItemIndex, next);
                } else {
                    let next = m.activeItemIndex + 1,
                        list = m.items;
                    if (next >= list.length) next = 0;
                    m.update(true, next);
                }
                break;
            // UP / LEFT to move backwards through items at current level
            case 'Up':
            case 'ArrowUp':
            case 'Left':
            case 'ArrowLeft':
                e.preventDefault();
                if (m.activeSubmenuItemIndex > -1) {
                    let next = m.activeSubmenuItemIndex - 1,
                    list = isMobile? m.items[m.activeItemIndex].submenu.mobileItems : m.items[m.activeItemIndex].submenu.desktopItems;
                    if (next < 0) next = isMobile ? list.length - 2 : list.length - 1; // don't include submenu close button in mobile mode
                    m.update(true, m.activeItemIndex, next);
                } else {
                    let next = m.activeItemIndex - 1,
                        list = m.items;
                    if (next < 0) next = list.length - 1;
                    m.update(true, next);
                }
                break;
            // TAB close menu (if open) and move to next tab element
            case 'Tab':
                if(isMobile) {
                    if (!m.hasSearch && m.activeItemIndex > -1) {
                        m.hide();
                    }
                } else {
                    m.update();
                }
                break;
            // SPACE/ENTER/RETURN to click a item
            case 'Spacebar':
            case ' ':
            case 'Enter':
            case 'Return':
                e.preventDefault();
                if (m.activeSubmenuItemIndex > -1) {
                    if(isMobile) {
                        m.items[m.activeItemIndex].submenu.mobileItems[m.activeSubmenuItemIndex].click();
                    } else {
                        m.items[m.activeItemIndex].submenu.desktopItems[m.activeSubmenuItemIndex].click();
                    }
                } else {
                    if (m.items[m.activeItemIndex].hasSubmenu) {
                        m.items[m.activeItemIndex].submenu.toggle.click();
                    } else {
                        m.items[m.activeItemIndex].link.click();
                    }
                }
                break;
        }
    });

    // define and trigger resize check

    const resize = () => {
        let prev = isMobile;
        isMobile = window.innerWidth < breakPoint.LG;
        if(!isMobile) m.storeTriggerPositions();
        if(isMobile !== prev) {
            if(!isMobile) {
                m.show();
                m.update(false,1); // 'home' is hidden on desktop, so set menu to item 1 (without setting focus)
            } else {
                m.update(false);
            }
            // loop through all submenus and force close them
            m.items.forEach(s => {
                if(s.hasSubmenu) s.submenu.hide(false);
            });
            mainNavigation.setMobileActive(false);
            m.mobileToggle.setAttribute('aria-expanded', false);
            mainNavigation.setDesktopActive(false);
            $html.classList.remove('mobile-menu-active');
            $html.classList.remove('desktop-menu-active');
        }
    };

    resize();
    window.addEventListener('resize', () => {
        if(!resizeRequested) {
            resizeRequested = true;
            setTimeout(() => {
                resize();
                resizeRequested = false;
            }, 200);
        }
    });

}
